// Spalten und Sortierfelder der Opportunity-Liste in der Form der Bedienleiste (`ListenSpalte`, listenVertrag.ts).
import type { ListenSpalte } from "../components/smartview/listenVertrag";
import { OPP_SPALTEN } from "./logik";

/** Alle wählbaren Spalten der Liste (Spaltenwahl). */
export const ALLE_SPALTEN: ListenSpalte[] = OPP_SPALTEN.map((s) => ({
  key: s.key,
  label: s.label,
  gruppe: s.gruppe,
  sortierbar: !!s.sort,
  fest: s.fest,
}));

/** Felder, nach denen sich sortieren lässt (Liste und Board). */
export const SORT_FELDER: ListenSpalte[] = OPP_SPALTEN.filter((s) => s.sort).map((s) => ({ key: s.key, label: s.label, sortierbar: true }));
